import type { OneNightLogEntry } from "../event-log";
import "../styles/one-night-ultimate-werewolf-tokens.css";
import "../styles/one-night-ultimate-werewolf-roster.css";

interface OneNightEventLogProps {
  readonly entries: readonly OneNightLogEntry[];
  readonly expanded: boolean;
  readonly onToggle: () => void;
}

export function OneNightEventLog({
  entries,
  expanded,
  onToggle,
}: OneNightEventLogProps) {
  const latest = entries[entries.length - 1] ?? null;

  return (
    <div
      className="onuw-event-log"
      data-testid="one-night-ultimate-werewolf-event-log"
      data-expanded={expanded ? "true" : "false"}
    >
      <button
        type="button"
        className="onuw-event-log-toggle"
        data-testid="one-night-ultimate-werewolf-event-log-toggle"
        aria-expanded={expanded}
        onClick={onToggle}
      >
        <span className="onuw-log-kicker">로그</span>
        <span className="onuw-log-latest">{latest?.text ?? "기록 없음"}</span>
        <span
          className="onuw-log-count"
          data-testid="one-night-ultimate-werewolf-event-log-count"
        >
          {entries.length}
        </span>
        <span className="onuw-log-chevron" aria-hidden="true">
          ▶
        </span>
      </button>
      <ul
        className="onuw-event-log-list"
        data-testid="one-night-ultimate-werewolf-event-log-list"
      >
        {entries
          .slice()
          .reverse()
          .map((entry, reversedIndex) => (
            <li key={`${entries.length - reversedIndex}-${entry.text}`}>
              <span className="onuw-log-phase">{entry.phase}</span>
              <span>{entry.text}</span>
            </li>
          ))}
      </ul>
    </div>
  );
}
